function mapBannerClickToAnalytics(data) {
    return {
        event: 'bannerClick',
        ecommerce: {
            click: {
                actionField: { list: data.location },
                products: [{ id: `ban_${data.id}`, name: data.name }]
            }
        }
    };
}

module.exports = mapBannerClickToAnalytics;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/dynamiccontent/atmmapper/banner-click-mapper.js
 **/